import React, { useState } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../layout/core'
import FranchiseList from './FranchiseList'
import OnboardingForm from './FranhiseOnboarding'
import ManageAgreement from './ManageAgreement/ManageAgreement'
import ViewClients from './ViewClients/ViewClients'
import OnboardingClientForm from './ClientsOnbaording'

const FranchisePage = () => {
  const [isOffsetLimit, setIsOffsetLimit] = useState<number>()

  return (
    <Routes>
      <Route
        path='/all-lists'
        element={
          <>
            <PageTitle breadcrumbs={[]}>All Franchises</PageTitle>
            <FranchiseList setIsOffsetLimit={setIsOffsetLimit} />
          </>
        }
      />
      <Route
        path='/onboarding'
        element={
          <>
            <PageTitle breadcrumbs={[]}>Onboarding</PageTitle>
            <OnboardingForm isOffsetLimit={isOffsetLimit} />
          </>
        }
      />
      <Route
        path='/manage-agreement/:uuid'
        element={
          <>
            <PageTitle breadcrumbs={[]}>Manage Agreement</PageTitle>
            <ManageAgreement />
          </>
        }
      />
      <Route
        path='/clients/:uuid'
        element={
          <>
            <PageTitle breadcrumbs={[]}>All Clients</PageTitle>
            <ViewClients />
          </>
        }
      />
      <Route
        path='clients/new-onboarding/:uuid'
        element={
          <>
            <PageTitle breadcrumbs={[]}>New Client OnBoarding</PageTitle>
            <OnboardingClientForm />
          </>
        }
      />
      <Route index element={<Navigate to='/franchise/all-lists' />} />
    </Routes>
  )
}

export default FranchisePage
